'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cafiApp = function () {
  var valores = void 0,
      financiaciones = void 0,
      codigoCF = void 0;
  var state = true;

  /**
   * Initial function. Set data, calc and print on screen. Also adds
   * a listener to cafi opener link.
   */
  var _init = function _init() {
    _set(vehicleData.dealersVehicles[0]);
    _calc();
    _print();
    document.querySelector('.cafi-open').addEventListener('click', _show);
  };

  /**
   * If the selected comcom has not financial data, this function 
   * finds the data of an default codcom. 
   * Search in the object provided by configurador.nissan.es (CB) if any
   * vehicle has the "N3D" product as default or only a product, it
   * sets as codcom only for calculation purposes.
   * @param {array} coches object returned by CB
   */
  var _changeCodcom = function _changeCodcom(coches) {
    var codcom = '';
    for (var i = 0; i < coches.length; i++) {
      if (codcom === '' && coches[i].financiaciones.length === 1) {
        codcom = coches[i].codigocomercial;
      } else if (coches[i].financiacionDefault === 'CNO3') {
        codcom = coches[i].codigocomercial;
      }
    }
    return codcom;
  };

  /**
   * Sets de "valores" object with the model datad provided.
   * Search de codcom (selected model o replaced) in the data provided
   * by CB and sets "valores" object which is sent to calc function.
   * @param {object} model selected model
   */
  var _set = function _set(model) {
    var codcom10 = model.vehicle.vcodcom17.substring(0, 10);
    var financiacion = void 0,
        tasa = void 0,
        duracion = void 0,
        vr = void 0;

    for (var i = 0; i < coches.length; i++) {
      if (coches[i].codigocomercial === codcom10) {
        financiaciones = coches[i].financiaciones;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = coches[i].financiaciones[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var f = _step.value;

            var financial = codigoCF ? codigoCF : coches[i].financiacionDefault;
            if (f.codigoCF === financial) {
              financiacion = f;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
    if (typeof financiacion === 'undefined') {
      state = false;
      var _codcom = _changeCodcom(coches);

      for (var i = 0; i < coches.length; i++) {
        if (coches[i].codigocomercial === _codcom) {
          financiaciones = coches[i].financiaciones;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = coches[i].financiaciones[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _f = _step2.value;

              var _financial = codigoCF ? codigoCF : coches[i].financiaciones.length === 1 ? coches[i].financiaciones[0].codigoCF : coches[i].financiacionDefault;
              if (_f.codigoCF === _financial) {
                financiacion = _f;
                break;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }
    }
    tasa = function tasa() {
      for (var a = 0; a < financiacion.duracion.length; a++) {
        if (financiacion.duracion[a].mes === financiacion.duracionDef) return parseFloat(financiacion.duracion[a].tasa);
      }
    };
    vr = function vr() {
      for (var a = 0; a < financiacion.vr.length; a++) {
        if (financiacion.vr[a].mes === financiacion.duracionDef) return parseFloat(financiacion.vr[a].vr);
      }
    };
    duracion = function duracion() {
      return {
        min: parseInt(financiacion.duracion[0].mes),
        max: parseInt(financiacion.duracion[financiacion.duracion.length - 1].mes)
      };
    };
    duracion();
    var matriculacion = 0;

    valores = {
      "codcom": model.vehicle.vcodcom17,
      "CF_tipo": parseFloat(financiacion.CF_tipo),
      "codigoCF": financiacion.codigoCF,
      "duracion": parseFloat(financiacion.duracionDef),
      "duracion_minima": parseFloat(duracion().min),
      "duracion_maxima": parseFloat(duracion().max),
      "CF_current": parseFloat(financiacion.CF_tipo),
      "gastos_registro": parseFloat(financiacion.gRegistro),
      "com_presta": parseFloat(financiacion.comPresta),
      "lim_usura": parseFloat(financiacion.limUsura),
      "imp_timbre_p": parseFloat(financiacion.impTimbre),
      "imp_timbre": parseFloat(financiacion.impTimbre),
      "tasa": tasa(),
      "tasas": financiacion.duracion,
      "com_apertura_p": parseFloat(financiacion.ca),
      "com_apertura_max": 0,
      "nominal_min": parseFloat(financiacion.nominalMin),
      "nominal_max": parseFloat(financiacion.nominalMax),
      "entrada_p": parseFloat(financiacion.entradaDef),
      "entrada_min_p": parseFloat(financiacion.entradaMin),
      "entrada_max_p": financiacion.entradaMax !== '0.0' ? parseFloat(financiacion.entradaMax) : 1,
      "s_cv_p": 0.03515,
      "s_cv_estado": parseFloat(financiacion.estadoCV),
      "s_pc_p": 0.01369,
      "s_pc_estado": parseFloat(financiacion.estadoPC),
      "s_sp_p": 0,
      "s_sp_estado": parseFloat(financiacion.estadoSP),
      "s_sa_p": 0,
      "s_sa_estado": parseFloat(financiacion.estadoSA),
      "s_cv_activo": true,
      "vr_p": typeof vr() === 'undefined' ? 0 : vr(),
      "vrs": financiacion.vr,
      "impuestos": parseFloat(model.prices.impuestos),
      "impuesto": (parseFloat(model.prices.impuestos) - 1) * 100,
      "impuestoMatricula": parseFloat(model.vehicle.nimpMatriculacion),
      "na": parseFloat(model.vehicle.nprecioNA),
      "transporte": parseFloat(model.prices.nprecioTransporte),
      "vr_tipo": financiacion.codigoVR,
      "descripcion": financiacion.descripcion,
      "perfil": "P",
      "seccion": model.vehicle.nseccionCB,
      "precioColor": parseFloat(model.prices.precioPintura * model.prices.impuestos),
      "precio": parseFloat(model.prices.precioMostrar),
      "precioVR": parseFloat(model.prices.precioMostrar) - parseFloat(model.prices.precioPintura * model.prices.impuestos),
      "descuento": parseFloat(codigoCF === 'CNIS' ? model.prices.precioDtoMostrarFinanClasica : model.prices.precioDtoMostrarFinanMP3D) - matriculacion,
      "periodicidad": "mensual",
      "vr": 0
    };
  };

  /**
   * Main function for calculate financial data. Uses "calcular" 
   * function from CB/cafi.js, save in session the values calculated
   * and print on screen.
   */
  var _calc = function _calc() {
    calcular(valores);
    salida.cuota_financiera = salida.cuota_financiera + ctes.pt.cpm;
    window.sessionStorage.setItem('cafi', JSON.stringify(_defineProperty({}, valores.codcom, salida)));
    _print();
  };

  /**
   * Prints in DOM the calculator and add listeners to inputs elements.
   */
  var _print = function _print() {
    var cuota_financiera = document.querySelectorAll('.js-cafi-cuota');
    cuota_financiera.forEach(function (element) {
      element.innerHTML = utils.formatPrice(salida.cuota_financiera, 1);
    });

    document.querySelector('.cafi-display').innerHTML = _template(salida);

    var tasa = function tasa(mes) {
      for (var a = 0; a < valores.tasas.length; a++) {
        if (valores.tasas[a].mes === mes) return parseFloat(valores.tasas[a].tasa);
      }
    };
    var vr = function vr(mes) {
      for (var a = 0; a < valores.vrs.length; a++) {
        if (valores.vrs[a].mes === mes) return parseFloat(valores.vrs[a].vr);
      }
    };
    document.querySelector('#downpayment').addEventListener('change', function () {
      valores.entrada = this.value;
      _calc();
      gtagApp.init({ page: 'detalle', area: gtag.area, model: gtag.modelo, financial: salida });
    });
    document.querySelector('#duration').addEventListener('change', function () {
      valores.duracion = this.value;
      valores.tasa = tasa(this.value);
      valores.vr_p = typeof vr(this.value) === 'undefined' ? 0 : vr(this.value);
      _calc();
      gtagApp.init({ page: 'detalle', area: gtag.area, model: gtag.modelo, financial: salida });
    });
    document.querySelector('.close').addEventListener('click', _hide);
    var services = document.querySelectorAll('.services');
    services.forEach(function (element) {
      element.addEventListener('change', function () {
        valores['s_' + element.dataset.service + '_activo_temp'] = element.checked;
        valores['s_' + element.dataset.service + '_activo'] = element.checked;
        _calc();
      });
    });
    var tabs = document.querySelectorAll('.js-cafi-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        $('.js-cafi-tab').removeClass('active');
        tab.classList.add('active');
        codigoCF = tab.dataset.cf;
        _set(vehicleData.dealersVehicles[0]);
        _calc();
        gtagApp.init({ page: 'detalle', area: gtag.area, model: gtag.modelo, financial: salida });
      });
    });
    _miniLegal();
  };

  /**
   * Sets the legal block for display, imported from CB/main.js.
   * It sets the legal block for each type of financial product.
   */
  var _legales = function _legales() {
    var vehicle = vehicleData.dealersVehicles[0].vehicle;
    var cadena = '';
    var numero2 = '<p class="numero-nota"><strong>(2)</strong></p>';
    var numero3 = '<p class="numero-nota"><strong>(3)</strong></p>';
    // n months of permanence
    var nPermanencia;
    if (typeof sTipoDato !== 'undefined') {
      if (sTipoDato === 'F' || sTipoDato === 'B') {
        nPermanencia = '36';
      } else if (sTipoDato === 'P') {
        nPermanencia = '36';
      }
    }

    var legalpriceObj = legal.getPriceLegal(vehicleData.dealersVehicles[0]);
    var $domLegalPrice = '<p>' + legalpriceObj.price + '</p>';
    cadena += '<p class="numero-nota" > <strong>(1)</strong></p >';
    cadena += $domLegalPrice;

    switch (valores.CF_tipo) {
      case 0:
        //Clasica
        var legalNoteClassic = vehicleData.dealersVehicles[0].prices.ofertaFinanClasica.vnotaLegal;
        console.log('legalNoteClassic', legalNoteClassic);
        var b = '<p>' + legalNoteClassic.replace('<p>', '').replace('</p>', '') + '</p>';

        if (salida.descuento === 0 || legalNoteClassic === '') {
          // Borramos la variable si no hay oferta o el texto legal está vacío
          b = '';
          numero2 = '';
        }

        cadena += numero2 + b + numero3 + '<div class="rci-legal"><p>Nissan ' + vehicleData.dealersVehicles[0].vehicle.vdisplayModelo + ' ' + vehicleData.dealersVehicles[0].vehicle.vgrado + ' com PVP promocional de ' + utils.formatPrice(salida.precio_oferta) + '&euro;. Crédito automóvel por ' + utils.formatPrice(salida.cuota_financiera + salida.com_presta) + '&euro; a ' + salida.duracion + ' meses, com financiamento RCI Banque sujeito à aprovação. PVP a pronto de ' + utils.formatPrice(salida.precio) + '&euro;. Financiamento de ' + utils.formatPrice(salida.nominal_servicios) + '&euro;, entrada de ' + utils.formatPrice(salida.entrada) + '&euro;, TAN de ' + utils.formatPrice(salida.tasa_base * 100, 2) + '%, TAEG de ' + utils.formatPrice(salida.tae, 4) + '% e MTIC de ' + utils.formatPrice(salida.total_adeudado) + '&euro;. Comissão de abertura de ' + utils.formatPrice(salida.com_apertura) + '&euro; e comissão de processamento de prestação de ' + ctes.pt.cpm + '&euro;/mês. Não inclui despesas administrativas e transporte. Visual não contratual.';
        console.log('cadena', cadena);
        break;
      case 1:
        //MP3D
        var legalNoteMP3D = vehicleData.dealersVehicles[0].prices.ofertaFinanMP3D.vnotaLegal;
        var a = '<p>' + legalNoteMP3D.replace('<p>', '').replace('</p>', '') + '</p>';

        if (salida.descuento === 0 || legalNoteMP3D === '') {
          // Borramos la variable si no hay oferta o el texto legal está vacío
          a = '';
          numero2 = '';
        }
        cadena += numero2 + a + numero3 + '<div class="rci-legal"><p>Nissan ' + vehicleData.dealersVehicles[0].vehicle.vdisplayModelo + ' ' + vehicleData.dealersVehicles[0].vehicle.vgrado + ' com PVP promocional de ' + utils.formatPrice(salida.precio_oferta) + '&euro;. Crédito automóvel por ' + utils.formatPrice(salida.cuota_financiera + salida.com_presta) + '&euro; a ' + salida.duracion + ' meses, com financiamento RCI Banque sujeito à aprovação. PVP a pronto de ' + utils.formatPrice(salida.precio) + '&euro;. Financiamento de ' + utils.formatPrice(salida.nominal_servicios) + '&euro;, entrada de ' + utils.formatPrice(salida.entrada) + '&euro;, TAN de ' + utils.formatPrice(salida.tasa_base * 100, 2) + '%, TAEG de ' + utils.formatPrice(salida.tae, 2) + '% e MTIC de ' + utils.formatPrice(salida.total_adeudado) + '&euro;. Comissão de abertura de ' + utils.formatPrice(salida.com_apertura) + '&euro; e comissão de processamento de prestação de ' + ctes.pt.cpm + '&euro;/mês. Pagamento Final/ VFMG (Valor Final Mínimo Garantido) ' + utils.formatPrice(salida.ultima_cuota) + '&euro; com possibilidade de entrega da viatura no ' + salida.duracion + ' mês em substituição do pagamento final, desde que sejam cumpridas as condições contratuais de devolução e de estado geral do veículo. Não inclui despesas administrativas e transporte. Visual não contratual.';

        break;
      case 2:
        //Leasing
        var legalNoteLeasing = undefined.iniciolegalMP3D;
        var c = '<p>' + legalNoteLeasing.replace('<p>', '').replace('</p>', '') + '</p>';
        if (salida.descuento === 0 || legalNoteLeasing) {
          // Borramos la variable si no hay oferta o el texto legal está vacío
          c = '';
          numero2 = '';
        }
        var txtPeninsula = peninsula ? 'Península y Baleares' : 'Canarias';
        cadena += numero2 + c + numero3 + '<p>Oferta leasing para ' + txtPeninsula + ', válida para empresas con un parque inferior a 10 vehículos financiando con RCI Banque SA Sucursal en España. Ejemplo de arrendamiento para ' + vehicleData.dealersVehicles[0].vehicle.vDisplayModelo + ' ' + bloqueDatosVeh.grado + ' ' + bloqueDatosVeh.motor + '. PFF ' + utils.formatPrice(salida.precio_oferta, 2) + '€  (IVA, transporte y Nissan Assistance no incluídos. Incluye promociones soportadas por Nissan).  Renta Total:' + utils.formatPrice(salida.coste_total, 2) + '€. Una entrega a cuenta de ' + utils.formatPrice(salida.entrada, 2) + '€. Importe del arrendamiento: ' + formatoPrecio(salida.nominal_servicios) + '€. Importe total adeudado: ' + utils.formatPrice(salida.total_adeudado, 2) + '€. ' + salida.duracion + ' rentas de ' + utils.formatPrice(salida.cuota_financiera, 2) + '€/mes y una opción de recompra por ' + utils.formatPrice(salida.ultima_cuota, 2) + '€. TIN ' + utils.formatPrice(salida.tasa_base * 100, 2) + '%. Comisión apertura: ' + utils.formatPrice(salida.com_apertura, 2) + '€. TAE: ' + utils.formatPrice(salida.tae, 2) + '%.  Importe mínimo del arrendamiento: ' + utils.formatPrice(eval(valores.nominal_min - 1), 2) + '€. Permanencia mínima: ' + nPermanencia + ' meses. Todos los importes son sin IVA. Incompatible con otras ofertas financieras. Para otros canales de venta o condiciones dirigirse a su concesionario Nissan. No incluye Gastos de Notaría.</p>';
        if (salida.s_cv_activo || salida.s_pc_activo) {
          cadena += 'Incluye ';
          if (salida.s_cv_activo) cadena += "Protección de pagos (" + utils.formatPrice(salida.s_cv_importe, 2) + "€) ";

          if (salida.s_pc_activo && !salida.s_cv_activo) cadena += "seguro de pérdida de carné (" + utils.formatPrice(salida.s_pc_importe, 2) + "€) con CASER durante toda la operación.";else if (salida.s_pc_activo && salida.s_cv_activo) cadena += "y seguro de pérdida de carné (" + utils.formatPrice(salida.s_pc_importe, 2) + "€) con CASER durante toda la operación.";
        }
        break;
    }
    cadena += '<p class="numero-nota"><strong>(4)</strong></p><p>Inclui desconto associado ao financiamento RCI Banque</p>';
    return cadena;
  };

  var _miniLegal = function _miniLegal() {
    var o3 = valores.CF_tipo === 1 ? '| VFMG: ' + utils.formatPrice(salida.ultima_cuota, 0) + '\u20AC | Com CR\xC9DITO O3' : '';
    document.querySelector('.js-cafi-miniLegal').innerHTML = 'COM RETOMA | DURA\xC7\xC3O: ' + salida.duracion + ' meses | TAEG: ' + utils.formatPrice(salida.tae, 2) + ' % | CAPITAL FINANCIADO *: ' + utils.formatPrice(salida.nominal_servicios, 0) + '\u20AC | ENTRADA ' + utils.formatPrice(salida.entrada, 0) + '\u20AC ' + o3;
  };

  /**
   * Shows the calculator, if it's opened then hide it.
   */
  var _show = function _show() {
    var display = document.querySelector('.cafi-display');
    if (display.classList.contains('opened')) {
      _hide();
    } else {
      display.classList.add('opened');
      $("html, body").animate({
        scrollTop: $(".cafi-display").offset().top
      }, 500);
      gtagApp.init({ page: 'detalle', area: gtag.area, model: gtag.modelo, financial: salida });
    }
  };

  /**
   * Hide the calculator
   */
  var _hide = function _hide() {
    var display = document.querySelector('.cafi-display');
    display.classList.remove('opened');
    $(document).ready(function () {
      $("html, body").animate({
        scrollTop: $(".vs_top_banner").offset().top
      }, 500);
    });
  };

  /**
   * Returns de DOM of the cafi for display in page
   * @param {object} salida financial data calculated
   */
  var _template = function _template(salida) {
    var tabs = '';
    financiaciones.forEach(function (element) {
      if (element.codigoCF == valores.codigoCF) {
        tabs += '<div class="js-cafi-tab tab active" data-cf="' + element.codigoCF + '" > ' + element.descripcion.toUpperCase() + '</div> ';
      } else {
        tabs += '<div class="js-cafi-tab tab" data-cf="' + element.codigoCF + '" > ' + element.descripcion.toUpperCase() + '</div> ';
      }
    });
    var cuota = salida.tae < valores.lim_usura * 100 ? '<tr class="cuota">\n          <td><div>\n            <span id="txt_cuota_label">MENSALIDADE</span><!-- %=rb.getString("calc_cuota") %--> <span class="numero-nota-enunciado">(3)</span>\n          </div></td>\n          <td><div>\n            <div class="precio-cuota cuota-mes"><span class="cifra">' + utils.formatPrice(salida.cuota_financiera, 1) + '</span><span class="euro">\u20AC</span><span class="plazo_cuota">/MES </span></div>\n          </div></td>\n        </tr>' : '<tr class="cuota">\n          <td colspan="2"><div>TAEG m\xE1xima ultrapassada, <br>por favor altere as condi\xE7\xF5es.</div></td>\n        </tr>';
    return '\n      <div class="container inner" >\n        <div class="tabs">\n          ' + tabs + '\n          <span class="close js-cafi-close"></span></div>\n        <div class="row">\n          <div class="col">\n            <div class="sliders">\n              <p>\n                <strong>ENTRADA: <span class="cifra">' + utils.formatPrice(salida.entrada, 0) + '</span>\u20AC</strong><br>\n                  <input type="range" name="downpayment" id="downpayment" min="' + salida.entrada_minima + '" max="' + salida.entrada_maxima + '" value="' + salida.entrada + '" step="100">\n              </p>\n                  <p>\n                    <strong>MESES: <span class="cifra">' + salida.duracion + '</span> meses</strong><br>\n                      <input type="range" name="duration" id="duration" min="' + valores.duracion_minima + '" max="' + valores.duracion_maxima + '" value="' + salida.duracion + '" step="12">\n              </p>\n            </div>\n          </div>\n                  <div class="col">\n                    <table id="desglose">\n                      <tbody>\n                        <tr id="aviso-iva" class="hidden">\n                          <td colspan="2"><p class="aviso-iva">Todos los importes son sin I.V.A.</p></td>\n                        </tr>\n                        <tr>\n                          <td><div>\n                            PVP RECOMENDADO <span class="numero-nota-enunciado">(1)</span>\n                          </div></td>\n                          <td><div>\n                            <span id="pvp">' + utils.formatPrice(salida.precio, 0) + '</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n                        <tr id="fila-pff-con-oferta" style="display: none;">\n                          <td><div>\n                            PRE\xC7O COM OFERTA <span class="numero-nota-enunciado-pff" style="display: none;">(2)</span>\n                          </div></td>\n                          <td><div>\n                            <span id="pff_oferta">17.750</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n                        <tr id="fila-precio-con-oferta">\n                          <td><div>\n                            PRE\xC7O COM OFERTA <span class="numero-nota-enunciado">(2)</span><p id="fila-incluye-impuestos" style="display: none;">(incluye impuestos)</p>\n                          </div></td>\n                          <td><div>\n                            <span id="pvp_oferta">' + utils.formatPrice(salida.precio_oferta, 0) + '</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n\n                        <tr>\n                          <td><div>\n                            <span class="txt_entrada_label">ENTRADA</span>\n                          </div><!-- %=rb.getString("calc_entrada") %--></td>\n                          <td><div>\n                            <span class="txt_entrada">' + utils.formatPrice(salida.entrada, 0) + '</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n                        <tr>\n                          <td><div>MESES</div></td>\n                          <td><div>\n                            <span id="txt_meses">' + salida.duracion + '</span><span class="unidades">M.</span>\n                          </div></td>\n                        </tr>\n                        <tr>\n                          <td><div>\n                            <span id="txt_capital_label">CAPITAL FINANCIADO (4)</span>\n                          </div><!-- %=rb.getString("calc_capital") %--></td>\n                          <td><div>\n                            <span id="capital_financiado">' + utils.formatPrice(salida.nominal_servicios, 2) + '</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n                        <tr>\n                          <td><div>COMISS\xC3O DE ABERTURA</div></td>\n                          <td><div>\n                            <span id="ca">' + utils.formatPrice(salida.com_apertura, 2) + '</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n                        <tr>\n                          <td><div>TAN</div></td>\n                          <td><div>\n                            <span id="tin">' + utils.formatPrice(salida.tasa_base * 100, 2) + '</span><span class="unidades">%</span>\n                          </div></td>\n                        </tr>\n                        <tr>\n                          <td><div>TAEG</div></td>\n                          <td><div>\n                            <span id="tae">' + utils.formatPrice(salida.tae, 2) + '</span><span class="unidades">%</span>\n                          </div></td>\n                        </tr>\n                        <tr>\n                          <td>\n                            <div>\n                              <span class="calc_coste"> MTIC</span>\n                            </div>\n                            <div>\n                              <span class="calc_coste_leasing" style="display: none;"> RENTA TOTAL</span>\n                            </div>\n                          </td>\n                          <td><div>\n                            <span id="importe_total_adeudado">' + utils.formatPrice(salida.total_adeudado, 2) + '</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n                        <tr id="valor_minimo" ' + (salida.ultima_cuota === 0 ? 'style = "display: none;"' : 'style = "display: table-row;"') + '>\n                          <td>\n                            <div>\n                              <span class="calc_valor">VFMG</span>\n                            </div>\n                            <div>\n                              <span class="calc_valor_leasing" style="display: none;">OPCI\xD3N DE RECOMPRA</span>\n                            </div>\n                          </td>\n                          <td><div>\n                            <span class="vr">' + utils.formatPrice(salida.ultima_cuota, 2) + '</span><span class="unidades">\u20AC</span>\n                          </div></td>\n                        </tr>\n                        ' + cuota + '\n                      </tbody>\n                    </table>\n                  </div>\n        </div>\n                <div class="legales">' + _legales() + '</div>\n      </div>\n    ';
  };

  return {
    init: _init,
    calc: _calc
  };
}();